// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1cIdo","icon":"SortAdornment_icon__iQhiO","up":"SortAdornment_up__S1Kwp","down":"SortAdornment_down__30JXh","active":"SortAdornment_active__22Vew"};